import { BtnParticipar } from '../../componentes/btnParticipar'
import { BtnRegistro } from '../../componentes/btnRegistro'
import { BtnSweetPalermo } from '../../componentes/btnSweetPalermo'
import { Video } from './componentes/video'

export const Home = () => {
    return (
        <>
            <section className="">
                <div className="wrapper mx-auto">
                    <img src="/assets/img/home1.png" alt="Sweet Palermo" />
                </div>
                {/* <div className="flex justify-center">
                    <BtnSweetPalermo label="Conoce Sweet Palermo" />
                </div> */}
                <div className="wrapper bg-[#CE3235] mt-4 flex flex-col items-center">
                    <p className="text-2xl text-white py-4 font-semibold m-0">
                        Participa con tu móvil o tablet
                    </p>
                </div>
                <div className="wrapper">
                    <img src="/assets/img/home2.png" alt="Sorteamos 3 Air Fryers" />
                </div>
                <div className="wrapper">
                    <Video />
                </div>
                <div className="wrapper">
                    <BtnParticipar />
                </div>
                <div className="wrapper pt-8">
                    <img src="/assets/img/home3.png" alt="Sorteamos 3 Air Fryers" />
                </div>
            </section>
        </>
    )
}
